// extracted by mini-css-extract-plugin
export default {"desktopOnly":"cRy1Pi","mobileOnly":"IQUkcZ"};